import { render, staticRenderFns } from "./ProveedorPantalla.vue?vue&type=template&id=59595dc2&"
import script from "./ProveedorPantalla.vue?vue&type=script&lang=ts&"
export * from "./ProveedorPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports